<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="标签使用明细"
    size="680px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <div class="search-from">
        <div></div>
        <div>
          <el-button
            :loading="loading"
            type="primary"
            @click="handleCurrentChange(1)">刷新</el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="开始序号"
          prop="beginTagNo"></el-table-column>
        <el-table-column
          label="结束序号"
          prop="endTagNo"></el-table-column>
        <el-table-column
          label="使用状态"
          width="100"
          :formatter="row => row.isUsed ? '已使用' : '未使用'"
          prop="isUsed"> </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </div>
  </el-drawer>
</template>
<script>
import AppraiseLable from '@/service/appraiseLable'
export default {
  name: 'ApplyTagDetailListModal',
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10, tagAssignId: '' },
      list: [],
      total: 0
    }
  },
  methods: {
    invalidtag() {},
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      AppraiseLable.gettaguseinfos({ ...this.config })
        .then(res => {
          this.loading = false
          const { records, total, result, message } = res.data
          if ([0, -13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options = {}) {
      this.config = { ...this.config, ...options }
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
